import React from 'react';
import { useParams } from 'react-router-dom';
import ProductGrid from '../components/ProductGrid';
import { featuredProducts, productCategories } from '../data/mockData';

const CategoryPage = () => {
  const { category } = useParams();
  
  const categoryData = productCategories.find(cat => cat.slug === category);
  const products = featuredProducts.filter(p => {
    if (category === 'sculpture') return p.category === 'sculpture';
    if (category === 'bird-cage-lightnings') return p.category === 'birdcage';
    if (category === 'unique-pieces') return p.category === 'unique';
    return false;
  });

  const getCategoryTitle = () => {
    if (category === 'sculpture') return 'Exquisite sculpture collection';
    if (category === 'bird-cage-lightnings') return 'Illuminating bird cage designs';
    if (category === 'unique-pieces') return 'One-of-a-kind unique masterpieces';
    return 'Our Collection';
  };

  return (
    <div className="min-h-screen bg-black pt-24">
      <ProductGrid
        products={products}
        title={getCategoryTitle()}
        subtitle={categoryData?.name || 'Collection'}
      />
    </div>
  );
};

export default CategoryPage;